import { HTMLAttributes } from 'react';
import './MiniLoader.scss';

interface Props {
  className?: string;
}

export default function MiniLoader({
  className = '',
  ...rest
}: Props & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={`MiniLoader ${className} d-flex align-items-center`}
    >
      <div className='lds-ring'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
